import { useEffect, useState } from "react";
import { Table } from "./Table";
import ModalBasic from "../elementos/Modal";
import { useTareasStore } from "../store/api";
import { Link } from "react-router-dom";
import { Tarea } from "../DTO/Tarea";
import { useCategoriaStore } from "../store/CategoriaStore";
import toast from "react-hot-toast";
import { globalApiError } from "../utils/generalApiError";
import { ApiErrorResponse } from "../DTO/ApiResponseError";
import axios from "axios";
import { Categoria } from "../DTO/Categoria";
import LoadingModal from "../elementos/LoadingModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListCheck, faMagnifyingGlass, faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";

export const Tareas = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [idtarea, setIdtarea] = useState(0);
  const [categoriaId, setcategoriaId] = useState("");
  const [disabled, setDisabled] = useState(false);
  const {
    eliminarTarea,
    creatTarea,
    exportarEnPdf,
    exportarEnExcel,
    obtenerTareasCompletadas,
  } = useTareasStore();
  const { obtenerTareas } = useTareasStore();
  const [categoriasDisponibles, setCategoriasDisponibles] = useState<Categoria[]>([]);
  const [tareas, setTareas] = useState<Tarea[]>([]);
  const [nombreFilter, setNombreFilter] = useState<string | null>(null);
  const [fechaFilter, setFechaFilter] = useState<string | null>(
    new Date().toISOString().split("T")[0],
  );
  const { findAllCategorias } = useCategoriaStore();
  const fecha = new Date().toISOString().split("T")[0];
  const [completadaFilter, setCompletadaFilter] = useState<boolean | null>(
    null,
  );

  const [limit, setLimit] = useState<number>(10);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Cargando tareas...");

  const formattedDate = (date: string) => {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    getTareas();
  }, [limit]);

  useEffect(() => {
    getTareasComletada();
    fetchAllCategorias();
  }, []);

  const getTareas = async () => {
    setLoadingMessage("Cargando tareas...");
    setLoading(true);
    try {
      const response = await obtenerTareas(
        nombreFilter,
        fechaFilter === "" ? null : fechaFilter,
        completadaFilter,
        categoriaId,
        limit,
      );
      setTareas(response);
    } catch (error) {
      toast.error(globalApiError(error));
    } finally {
      setLoading(false);
    }
  };

const getTareasComletada = async () => {
  try {
    const response = await obtenerTareasCompletadas();

    if (response === null) {
      return;
    }

    const tareasVencidas = response.filter(
      (tarea: Tarea) => tarea.fecha < fecha,
    );

    if (tareasVencidas.length === 0) {
      return;
    }

    await Promise.all(
      tareasVencidas.map((tarea: Tarea) =>
        creatTarea(
          tarea.id,
          tarea.nombre,
          tarea.descripcion,
          tarea?.categoriaId,
          fecha,
          tarea.hora,
          tarea.completada,
          tarea.aviso,
          tarea.fechaHoraAvisoPersonalizado,
        ),
      ),
    );
    await getTareas();
  } catch (error) {
    toast.error(globalApiError(error));
  }
};

  const handleConfirmDelete = async () => {
    setDisabled(true);
    setLoadingMessage("Eliminando tarea...");
    setLoading(true);
    try {
      await eliminarTarea(idtarea);
      await getTareas();
      setModalOpen(false);
      toast.success('Se ha eliminado correctamente la tarea');
    } catch (error) {
      toast.error(globalApiError(error));
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  const resetFilters = () => {
    setNombreFilter(null);
    setFechaFilter(new Date().toISOString().split("T")[0]);
    setCompletadaFilter(null);
    setcategoriaId("");
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleOpenModal = (id: number) => {
    setIdtarea(id);
    setModalOpen(true);
  };

  const changeCompletada = async (tarea: Tarea) => {
    setDisabled(true);
    setLoadingMessage("Actualizando tarea...");
    setLoading(true);
    try {
      await creatTarea(
        tarea?.id,
        tarea?.nombre,
        tarea?.descripcion,
        tarea?.categoriaId,
        tarea?.fecha,
        tarea?.hora,
        true,
        tarea.aviso,
        tarea.fechaHoraAvisoPersonalizado
      );
      toast.success('Tarea compleada correctamente');
      await getTareas();
    } catch (error) {
      toast.error(globalApiError(error));
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  const exportarPdf = async () => {
    setDisabled(true);
    setLoadingMessage("Generando PDF...");
    setLoading(true);
    try {
      await exportarEnPdf(nombreFilter, fechaFilter, categoriaId, completadaFilter, limit);
      toast.success('PDF exportado correctamente');
    } catch (error) {
      await mostrarErrorBlob(error);
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  const mostrarErrorBlob = async (error: unknown) => {
    if (
      axios.isAxiosError<ApiErrorResponse | Blob>(error) &&
      error.response?.data instanceof Blob
    ) {
      try {
        const text = await error.response.data.text();
        const apiError = JSON.parse(text) as ApiErrorResponse;

        if (apiError.fieldErrors) {
          const messages = Object.values(apiError.fieldErrors);

          if (messages.length > 0) {
            toast.error(messages.join(", "));
            return;
          }
        }

        toast.error(apiError.message || "Ha ocurrido un error inesperado.");
        return;
      } catch {
        // Continúa con el mensaje global de fallback
      }
    }

    toast.error(globalApiError(error));
  };

  const exportarExcel = async () => {
    setDisabled(true);
    setLoadingMessage("Generando Excel...");
    setLoading(true);
    try {
      await exportarEnExcel(nombreFilter, fechaFilter, categoriaId, completadaFilter, limit);
      toast.success('Excel exportado correctamente');
    } catch (error) {
      await mostrarErrorBlob(error);
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  const fetchAllCategorias = async () => {
    try {
      const response = await findAllCategorias();
      setCategoriasDisponibles(response);
    } catch (error) {
      toast.error(globalApiError(error));
    }
  };

  return (
    <div className="container">
      <LoadingModal show={loading} message={loadingMessage} />
      <>
        <div>
          <div className="card p-3 mb-3 shadow-sm">
            <div className="row g-3 align-items-center">
              <div className="col-md-3">
                <label htmlFor="nombre" className="form-label">
                  Nombre:
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="nombre"
                  value={nombreFilter ?? ""}
                  onChange={(e) => setNombreFilter(e.target.value)}
                  placeholder="Buscar por nombre"
                />
              </div>

              <div className="col-md-3">
                <label htmlFor="categoria" className="form-label">
                  Categoria:
                </label>
                <select
                  id="completadaSelect"
                  className="form-select"
                  required
                  value={categoriaId}
                  onChange={(e) => {
                    setcategoriaId(e.target.value);
                  }}
                >
                  <option value="">Selecciona una categoría</option>
                  {categoriasDisponibles.map((cat) => (
                    <option key={cat.id} value={String(cat.id)}>
                      {cat.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label htmlFor="fecha" className="form-label">
                  Fecha:
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="fecha"
                  value={fechaFilter ?? ""}
                  onChange={(e) => setFechaFilter(e.target.value)}
                />
              </div>

              <div className="col-md-3">
                <label htmlFor="completadaSelect" className="form-label">
                  Completada:
                </label>
                <select
                  id="completadaSelect"
                  className="form-select"
                  value={
                    completadaFilter === null
                      ? "null"
                      : completadaFilter === false
                        ? "false"
                        : "true"
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    setCompletadaFilter(
                      value === "null"
                        ? null
                        : value === "false"
                          ? false
                          : true,
                    );
                  }}
                >
                  <option value="null">No consta</option>
                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>
              </div>
              <div className="col-md-12 d-flex align-items-end justify-content-end">
                <div
                  className="col-md-5 d-flex align-items-end justify-content-end"
                >

                  <button
                    type="button"
                    className="btn btn-outline-secondary w-90"
                    onClick={resetFilters}
                  >
                    Limpiar Filtros
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary ms-2 me-2 w-30 "
                    onClick={getTareas}
                    disabled={loading}
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card shadow-sm">
          <div className="card-body p-3">
            <Table>
              {tareas.length > 0 ? (
                tareas.map((tarea, index) => (
                  <tr key={index}>
                    <td>{tarea.nombre}</td>
                    <td
                      className="desc"
                      title={tarea.descripcion}
                    >
                      <div className="desc-text">
                        {tarea.descripcion}
                      </div>
                    </td>
                    <td>
                      {tarea?.categoriaNombre
                        ? tarea?.categoriaNombre
                        : "Sin asignar"}
                    </td>
                    <td>{formattedDate(tarea.fecha)}</td>
                    <td>{tarea.hora}</td>
                    <td>{tarea.completada ? "Completada" : "Pendiente"}</td>
                    <td>{tarea.aviso ? "Sí" : "No"}</td>
                    <td>
                      <Link
                        to={`/editarTarea/${tarea.id}`}
                        className="btn btn-sm btn-primary me-2 btn-accions"
                        aria-label="Editar tarea"
                        title="Editar tarea"
                      >
                        <FontAwesomeIcon icon={faPenToSquare} className="medida-icono"   />
                      </Link>
                      <button
                        disabled={disabled}
                        onClick={() => handleOpenModal(tarea.id)}
                        className="btn btn-sm btn-danger me-2 btn-accions"
                       aria-label="Borrar tarea"
                        title="Borrar tarea"
                      >
                         <FontAwesomeIcon icon={faTrashCan} className="medida-icono"   />
                      </button>
                      {!tarea.completada && (
                        <button
                          disabled={disabled}
                          onClick={() => changeCompletada(tarea)}
                          className="btn btn-sm btn-success btn-accions"
                           aria-label="Comenzar tarea"
                            title="Comenzar tarea"
                        >
                          <FontAwesomeIcon icon={faListCheck} className="medida-icono"   />
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center">
                    No hay tareas disponibles en este momento
                  </td>
                </tr>
              )}
            </Table>

            <div className="d-flex mt-3 div-global-botones">
              <div className="div-botones-agregar ">
                <Link
                  className="btn btn-primary boton-agregar"
                  to={"/crearTarea"}
                >
                  <p className="title-botones"> Agregar Tarea</p>
                </Link>
              </div>
              <div className="div-botones-exportar">
                <button
                  disabled={disabled}
                  className="btn  btn-dark me-2  boton-pdf"
                  onClick={() => {
                    exportarPdf();
                  }}
                >
                  <p className="title-botones">Exportar PDF</p>
                </button>

                <button
                  disabled={disabled}
                  className="btn btn-dark boton-excel"
                  onClick={exportarExcel}
                >
                  <p className="title-botones"> Exportar Excel</p>
                </button>
              </div>
            </div>

            <ModalBasic
              show={modalOpen}
              onClose={handleCloseModal}
              onConfirm={handleConfirmDelete}
            />
          </div>
        </div>
        <div
          style={{ marginBottom: "70px" }}
          className="d-flex justify-content-start mt-3 align-items-center"
        >
          <div className="me-3">Filas por página:</div>
          <div className="paginacion">
            <select
              id="completadaSelect"
              className="form-select"
              value={limit}
              onChange={(e) => {
                setLimit(parseInt(e.target.value));
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={10000}>Todas</option>
            </select>
          </div>
        </div>
      </>
    </div>
  );
};
